import { gql } from '@apollo/client';

const VisionandMissionQueryEn = gql`
  query MyQuery {
  nodeVissionAndMissions(first: 10, langcode: "en") {
    nodes {
      __typename
      id
      title
      path
      bannerImage {
        url
      }
      visionAndMissionPoint {
        ... on ParagraphWorkingModelPoint {
          id
          pointsDescription
          pointsTitle
          iconWithWorkingModelPo {
            url
            alt
          }
        }
      }
    }
  }
}
`;

export default VisionandMissionQueryEn;
